"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxFetchLocationSuggestionsArgs = void 0;
var HxGeoCoordinates_1 = require("./HxGeoCoordinates");
var HxLocationAvailabilityData_1 = require("./HxLocationAvailabilityData");
function serializeHxFetchLocationSuggestionsArgs(_arg) {
    var output = [];
    output.push(_arg.requestId);
    output.push(_arg.queryString);
    output.push(_arg.maxResults);
    output.push(_arg.sources);
    output.push(_arg.culture);
    output.push(HxGeoCoordinates_1.serializeHxGeoCoordinates(_arg.localCoordinates));
    output.push(_arg.availableConferenceRoomsOnly);
    output.push(_arg.locationAvailability !== undefined);
    if (_arg.locationAvailability !== undefined) {
        output.push(HxLocationAvailabilityData_1.serializeHxLocationAvailabilityData(_arg.locationAvailability));
    }
    output.push(_arg.manualSyncModeBehavior);
    return output;
}
exports.serializeHxFetchLocationSuggestionsArgs = serializeHxFetchLocationSuggestionsArgs;
